module.exports = __webpack_public_path__ + "static/media/weather-icon.d4600d58.svg";